import React from "react";
import { getAuthItem } from "../utils/authStorage";
import "./Header.css";

const Header = ({ isSidebar, setIsSidebar, onLogout }) => {
  const toggleSidebar = () => setIsSidebar((prev) => !prev);
  const userName = getAuthItem("userName") || "Admin";

  const handleLogout = (e) => {
    e?.preventDefault?.();
    onLogout?.(e);
  };

  return (
    <header className="admin-header">
      <button
        type="button"
        className="admin-header-toggle"
        onClick={toggleSidebar}
        aria-label="Toggle menu"
      >
        <i className="fas fa-bars" />
      </button>
      <div className="admin-header-spacer" />
      {onLogout && (
        <button
          type="button"
          className="admin-header-logout"
          onClick={handleLogout}
          aria-label="Logout"
        >
          <i className="fas fa-sign-out-alt" />
          <span>Logout</span>
        </button>
      )}
      <div className="admin-header-user">
        <div className="admin-header-avatar" aria-hidden="true">
          {(userName || "A").charAt(0).toUpperCase()}
        </div>
        <div className="admin-header-user-inner">
          <span className="admin-header-name">{userName}</span>
          <span className="admin-header-role">Exchange Admin</span>
        </div>
      </div>
    </header>
  );
};

export default Header;
